import { BrowserModule } from "@angular/platform-browser";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { ModalModule } from "ngx-modialog-7";
import { BootstrapModalModule } from "ngx-modialog-7/plugins/bootstrap";
import { DxScrollViewModule } from "devextreme-angular";
import { AppComponent } from "./app.component";
import { AppHeaderComponent } from "./core/views/app-header/app-header.component";
import { AppRightContainerComponent } from "./core/views/app-right-container/app-right-container.component";
import { ConfigJsonModelService } from "./core/models/config-json-model.service";
import { HttpService } from "./services/http.service";
import { LanguageJsonModelService } from "./core/models/language-json-model.service";
import { ConfigDocModelService } from "./core/models/config-doc-model.service";
import { CourseStructureModelService } from "./core/models/course-structure-model.service";
import { CourseMenuModelService } from "./core/models/course-menu-model.service";
import { CourseContextModelService } from "./core/models/course-context-model.service";
import { AppHeaderModelService } from "./core/views/app-header/app-header-model.service";
import { AppHeaderModelServiceAdaptive } from "./core/views/adaptive/app-header/app-header-model.service";
import { AppSidebarModelService } from "./core/views/app-sidebar/app-sidebar-model.service";
import { DescriptorModelService } from "./core/models/descriptor-model.service";
import { CourseControllerService } from "./core/controls/course-controller.service";
import { AppSidebarComponent } from "./core/views/app-sidebar/app-sidebar.component";
import { RubricInterfaceComponent } from "./core/views/rubric-interface/rubric-interface.component";
import { ScreenControllerService } from "./core/controls/screen-controller.service";
import { NavigationComponent } from "./core/views/navigation/navigation.component";
import { DefinitionPopupComponent } from "./core/views/definition-popup/definition-popup.component";
import { GeolocationComponent } from "./core/views/geolocation/geolocation.component";
import { GlossaryComponent } from "./core/views/glossary/glossary.component";
import { AppPageHeaderComponent } from "./core/views/app-page-header/app-page-header.component";
import { AppPageHeaderComponentAdaptive } from "./core/views/adaptive/app-page-header/app-page-header.component";
import { DefinitionModelService } from "./core/models/definition-model.service";
import { GeoLocationModelService } from "./core/views/geolocation/geolocation.model.service";
import { ModalPopupService } from "./services/modal-popup.service";
import { CourseTimerService } from "./services/course-timer.service";
import { StateSpecificContentModelService } from "./core/models/state-specific-content-model.service";
import { RouterModule, UrlSerializer } from "@angular/router";
import { RCPCommonModule } from "app/rcp-common.module";
import { AppServices } from "app/app.services";
import { appUrlSerializer } from "app/providers/app.urlSerializer";
import { DialogModal } from "./directives/dialog-popup/dialog-modal-popup.directive";
import { LoaderAnimationDirective } from "./directives/loader-animation/loader-animation.directive";
import { LoaderService } from "./directives/loader-animation/loader.service";
import { PageLoaderAnimationDirective } from "./directives/page-loader-animation/page-loader-animation.directive";
import { PageLoaderService } from "./directives/page-loader-animation/page-loader.service";
import { PresentationModePopupComponent } from "./core/views/presentation-mode-popup/presentation-mode-popup.component";
import { PresentationModePopupModelService } from "./core/views/presentation-mode-popup/presentation-mode-popup-model.service";
import { OrientationModelService } from "./core/models/orientation-model.service";
import { OrientationService } from "./services/orientation.service";
import { ApplicationUtilityService } from "./services/application-utility.service";
import { SettingModelService } from "./core/models/setting-model.service";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { AppHeaderComponentAdaptive } from "./core/views/adaptive/app-header/app-header.component";
import { AppProgressCardComponent } from "./core/views/adaptive/app-progress-card/app-progress-card.component";
import { ProgressSpinnerDirective } from "./directives/progress-spinner/progress-spinner.component";
import { ThemingService } from "./services/theming.service";
import { AdaptiveCourseModelService } from "./core/models/adaptive-course-model.service";
import { LaunchDarklyService } from "./launch-darkly/launch-darkly.service";
@NgModule({
	declarations: [
		AppComponent,
		AppHeaderComponent,
		AppHeaderComponentAdaptive,
		AppSidebarComponent,
		AppRightContainerComponent,
		AppPageHeaderComponent,
		AppPageHeaderComponentAdaptive,
		RubricInterfaceComponent,
		NavigationComponent,
		DefinitionPopupComponent,
		AppPageHeaderComponent,
		GeolocationComponent,
		GlossaryComponent,
		DialogModal,
		LoaderAnimationDirective,
		PageLoaderAnimationDirective,
		PresentationModePopupComponent,
		AppProgressCardComponent,
		ProgressSpinnerDirective,
	],
	imports: [
		BrowserModule,
		FormsModule,
		HttpClientModule,
		ModalModule.forRoot(),
		BootstrapModalModule,
		DxScrollViewModule,
		PerfectScrollbarModule,
		RouterModule.forRoot([
			{
				path: "dragdrop_mobile_adaptive",
				loadChildren:
					() => import('./rubrics/adaptive/dragdrop-mobile/dragdrop-mobile.module').then(m => m.DragDropMobileAdaptiveModule),
			},
			{
				path: "interview_adaptive",
				loadChildren:
					() => import('./rubrics/adaptive/interview/interview.module').then(m => m.InterviewAdaptiveModule),
			},
			{
				path: "scenario_multichoice_adaptive",
				loadChildren:
					() => import('./rubrics/adaptive/scenario_multichoice/scenario_multichoice.module').then(m => m.ScenarioMultiChoiceModule),
			},
			{
				path: "threescreen_adaptive",
				loadChildren:
					() => import('./rubrics/adaptive/threescreen/threescreen.module').then(m => m.ThreescreenModule),
			},
			{
				path: "mcq_adaptive",
				loadChildren: () => import('./rubrics/adaptive/mcq/mcq.module').then(m => m.MCQAdaptiveModule),
			},
			{
				path: "dragdrop_adaptive",
				loadChildren:
					() => import('./rubrics/adaptive/dragdrop/dragdrop.module').then(m => m.DragDropAdaptiveModule),
			},
			{
				path: "testout_adaptive",
				loadChildren:
					() => import('./rubrics/adaptive/testout/testout.module').then(m => m.TestoutAdaptiveModule),
			},
			{
				path: "fourcards_adaptive",
				loadChildren:
					() => import('./rubrics/adaptive/fourcards/fourcards.module').then(m => m.FourcardsAdaptiveModule),
			},
			{
				path: "videobric_adaptive",
				loadChildren:
					() => import('./rubrics/adaptive/videobric/videobric.module').then(m => m.VideobricAdaptiveModule),
			},
			{
				path: "iconclick_adaptive",
				loadChildren:
					() => import('./rubrics/adaptive/iconclick/iconclick.module').then(m => m.IconclickAdaptiveModule),
			},
			{
				path: "hotspot_adaptive",
				loadChildren:
					() => import('./rubrics/adaptive/hotspot/hotspot.module').then(m => m.HotspotAdaptiveModule),
			},
			{
				path: "learnerreflection_adaptive",
				loadChildren:
					() => import('./rubrics/adaptive/learnerreflection/learnerreflection.module').then(m => m.LearnerreflectionAdaptiveModule),
			},
			{
				path: "videobric2",
				loadChildren: () => import('./rubrics/videobric2/videobric2.module').then(m => m.VideobricModule),
			},
			{
				path: "videobric3",
				loadChildren: () => import('./rubrics/videobric2/videobric2.module').then(m => m.VideobricModule),
			},
			{
				path: "videobric4",
				loadChildren: () => import('./rubrics/videobric2/videobric2.module').then(m => m.VideobricModule),
			},
			{
				path: "dualdragdrop",
				loadChildren:
					() => import('./rubrics/dualdragdrop/dualdragdrop.module').then(m => m.DualdragdropModule),
			},
			{
				path: "dualdragdropmobile",
				loadChildren:
					() => import('./rubrics/dualdragdropmobile/dualdragdropmobile.module').then(m => m.DualdragdropMobileModule),
			},
			{
				path: "multiplequiz",
				loadChildren:
					() => import('./rubrics/multiplequiz/multiplequiz.module').then(m => m.MultipleQuizModule),
			},
			{
				path: "iconclick",
				loadChildren: () => import('./rubrics/iconclick/iconclick.module').then(m => m.IconclickModule),
			},
			{
				path: "videoclicktoreveal",
				loadChildren:
					() => import('./rubrics/videoclicktoreveal/videoclicktoreveal.module').then(m => m.VideoclicktorevealModule),
			},
			{
				path: "bulletlistbuilder",
				loadChildren:
					() => import('./rubrics/bulletlistbuilder/bulletlistbuilder.module').then(m => m.BulletlistbuilderModule),
			},
			{
				path: "dragdropcolumn",
				loadChildren:
					() => import('./rubrics/dragdropcolumn/dragdropcolumn.module').then(m => m.DragdropcolumnModule),
			},
			{
				path: "dragdropcolumnmobile",
				loadChildren:
					() => import('./rubrics/dragdropcolumnmobile/dragdropcolumnmobile.module').then(m => m.DragdropcolumnMobileModule),
			},
			{
				path: "peoplereveal",
				loadChildren:
					() => import('./rubrics/peoplereveal/peoplereveal.module').then(m => m.PeoplerevealModule),
			},
			{
				path: "hotspot_vec",
				loadChildren:
					() => import('./rubrics/hotspot_vec/hotspot_vec.module').then(m => m.HotspotVecModule),
			},
			{
				path: "hrmentor",
				loadChildren: () => import('./rubrics/hrmentor/hrmentor.module').then(m => m.HRMentorModule),
			},
			{
				path: "clicktoreveal",
				loadChildren:
					() => import('./rubrics/clicktoreveal/clicktoreveal.module').then(m => m.ClicktorevealModule),
			},
			{
				path: "clicktoreveal_adaptive",
				loadChildren:
					() => import('./rubrics/adaptive/clicktoreveal/clicktoreveal.module').then(m => m.ClicktorevealAcpModule),
			},
			{
				path: "slidermcq",
				loadChildren: () => import('./rubrics/slidermcq/slidermcq.module').then(m => m.SlidermcqModule),
			},
			{
				path: "ourcommitment",
				loadChildren:
					() => import('./rubrics/ourcommitment/ourcommitment.module').then(m => m.OurcommitmentModule),
			},
			{
				path: "resourcespage",
				loadChildren:
					() => import('./rubrics/resourcespage/resourcespage.module').then(m => m.ResourcesPageModule),
			},
			{
				path: "resourcespage_adaptive",
				loadChildren:
					() => import('./rubrics/adaptive/resourcespage/resourcespage.module').then(m => m.ResourcesPageAdaptiveModule),
			},
			{
				path: "certificate",
				loadChildren:
					() => import('./rubrics/certificate/certificate.module').then(m => m.CertificateModule),
			},
			{
				path: "certificate_adaptive",
				loadChildren:
					() => import('./rubrics/adaptive/certificate/certificate.module').then(m => m.CertificateAcpModule),
			},
			{
				path: "spotlight2",
				loadChildren: () => import('./rubrics/spotlight2/spotlight2.module').then(m => m.Spotlight2Module),
			},
			{
				path: "finalquiz",
				loadChildren: () => import('./rubrics/finalquiz/finalquiz.module').then(m => m.FinalquizModule),
			},
			{
				path: "closerlook2",
				loadChildren:
					() => import('./rubrics/closerlook2/closerlook2.module').then(m => m.Closerlook2Module),
			},
			{
				path: "quicksheet",
				loadChildren: () => import('./rubrics/quicksheet/quicksheet.module').then(m => m.QuicksheetModule),
			},
			{
				path: "knowledgeassessment",
				loadChildren:
					() => import('./rubrics/knowledgeassessment/knowledgeassessment.module').then(m => m.KnowledgeassessmentModule),
			},
			{
				path: "flashright",
				loadChildren: () => import('./rubrics/flashright/flashright.module').then(m => m.FlashrightModule),
			},
			{
				path: "flashright_adaptive",
				loadChildren:
					() => import('./rubrics/adaptive/flashright/flashright.module').then(m => m.FlashrightAcpModule),
			},
			{
				path: "bucketlist",
				loadChildren: () => import('./rubrics/bucketlist/bucketlist.module').then(m => m.BucketlistModule),
			},
			{
				path: "scenariomultchoice",
				loadChildren:
					() => import('./rubrics/scenariomultchoice/scenariomultchoice.module').then(m => m.ScenariomultchoiceModule),
			},
			{
				path: "quicktips",
				loadChildren: () => import('./rubrics/quicktips/quicktips.module').then(m => m.QuicktipsModule),
			},
			{
				path: "pollsurvey",
				loadChildren: () => import('./rubrics/pollsurvey/pollsurvey.module').then(m => m.PollsurveyModule),
			},
			{
				path: "stillsandtext2",
				loadChildren:
					() => import('./rubrics/stillsandtext2/stillsandtext2.module').then(m => m.Stillsandtext2Module),
			},
			{
				path: "expertinterview2",
				loadChildren:
					() => import('./rubrics/expertinterview2/expertinterview2.module').then(m => m.Expertinterview2Module),
			},
			{
				path: "animation",
				loadChildren: () => import('./rubrics/animation/animation.module').then(m => m.AnimationModule),
			},
			{
				path: "topicintro",
				loadChildren: () => import('./rubrics/topicintro/topicintro.module').then(m => m.TopicintroModule),
			},
			{
				path: "multiplechoice",
				loadChildren:
					() => import('./rubrics/multiplechoice/multiplechoice.module').then(m => m.MultiplechoiceModule),
			},
			{
				path: "exam",
				loadChildren: () => import('./rubrics/exam/exam.module').then(m => m.ExamModule),
			},
			{
				path: "decisionpoint",
				loadChildren:
					() => import('./rubrics/decisionpoint/decisionpoint.module').then(m => m.DecisionpointModule),
			},
			{
				path: "quadwithtext",
				loadChildren:
					() => import('./rubrics/quadwithtext/quadwithtext.module').then(m => m.QuadwithtextModule),
			},
			{
				path: "lawinbrief",
				loadChildren: () => import('./rubrics/lawinbrief/lawinbrief.module').then(m => m.LawinbriefModule),
			},
			{
				path: "explorequadrants",
				loadChildren:
					() => import('./rubrics/explorequadrants/explorequadrants.module').then(m => m.ExplorequadrantsModule),
			},
			{
				path: "conclusion_exit2",
				loadChildren:
					() => import('./rubrics/conclusion-exit2/conclusion-exit2.module').then(m => m.ConclusionExit2Module),
			},
			{
				path: "fourcards",
				loadChildren: () => import('./rubrics/fourcards/fourcards.module').then(m => m.FourCardsModule),
			},
			{
				path: "learnerreflection",
				loadChildren:
					() => import('./rubrics/learnerreflection/learnerreflection.module').then(m => m.LearnerreflectionModule),
			},
			{
				path: "hotspot",
				loadChildren: () => import('./rubrics/hotspot/hotspot.module').then(m => m.HotspotModule),
			},
			{
				path: "interview",
				loadChildren: () => import('./rubrics/interview/interview.module').then(m => m.InterviewModule),
			},
			{
				path: "branching",
				loadChildren: () => import('./rubrics/branching/branching.module').then(m => m.BranchingModule),
			},
			{
				path: "summary",
				loadChildren: () => import('./rubrics/summary/summary.module').then(m => m.SummaryModule),
			},
			{
				path: "summary_adaptive",
				loadChildren:
					() => import('./rubrics/adaptive/summary/summary.module').then(m => m.SummaryAcpModule),
			},
			{
				path: "dummy",
				loadChildren:
					() => import('./rubrics/default-router/default-router.module').then(m => m.DefaultRouterModule),
			},
			{
				path: "**",
				loadChildren:
					() => import('./rubrics/default-router/default-router.module').then(m => m.DefaultRouterModule),
			},
		]),
		RCPCommonModule,
		AppServices,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	providers: [
		CourseControllerService,
		ConfigJsonModelService,
		HttpService,
		LanguageJsonModelService,
		ConfigDocModelService,
		CourseStructureModelService,
		CourseMenuModelService,
		CourseContextModelService,
		AppHeaderModelService,
		AppHeaderModelServiceAdaptive,
		AppSidebarModelService,
		PresentationModePopupModelService,
		DescriptorModelService,
		ScreenControllerService,
		DefinitionModelService,
		CourseTimerService,
		ModalPopupService,
		GeoLocationModelService,
		StateSpecificContentModelService,
		LoaderService,
		PageLoaderService,
		OrientationService,
		OrientationModelService,
		ApplicationUtilityService,
		SettingModelService,
		ThemingService,
		AdaptiveCourseModelService,
		LaunchDarklyService,
		{ provide: UrlSerializer, useClass: appUrlSerializer },
	],
	entryComponents: [
		DialogModal,
		LoaderAnimationDirective,
		PageLoaderAnimationDirective,
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
